(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["uk-redirect"]) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-uk-redirect]');
    if (!roots.length) return;

    const storageKey = 'sos-uk-redirect-dismissed';
    const ukHosts = ['soshydration.co.uk'];

    function parseCountries(value) {
      return String(value || 'GB,UK')
        .split(',')
        .map((code) => code.trim().toUpperCase())
        .filter(Boolean);
    }

    function isUkHost(host) {
      const value = String(host || '').toLowerCase();
      return ukHosts.some((ukHost) => value === ukHost || value.endsWith('.' + ukHost));
    }

    function readDismissed() {
      try {
        return window.localStorage.getItem(storageKey) === '1';
      } catch (e) {
        return false;
      }
    }

    function writeDismissed() {
      try {
        window.localStorage.setItem(storageKey, '1');
      } catch (e) {}
    }

    async function detectCountry(fallback) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const res = await fetch(root + 'browsing_context_suggestions.json', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (res.ok) {
          const data = await res.json();
          const handle =
            data &&
            data.detected_values &&
            data.detected_values.country &&
            data.detected_values.country.handle;
          if (handle) return String(handle).toUpperCase();
        }
      } catch (e) {}
      return String(fallback || '').toUpperCase();
    }

    function bind(dialog) {
      const url = dialog.getAttribute('data-url') || 'https://www.soshydration.co.uk';
      const host = dialog.getAttribute('data-host') || window.location.hostname;
      const countries = parseCountries(dialog.getAttribute('data-countries'));
      const designMode = Boolean(window.Shopify && window.Shopify.designMode);

      if (isUkHost(host) || isUkHost(window.location.hostname)) return;

      function show() {
        if (dialog.open) return;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      }

      function dismiss() {
        writeDismissed();
        if (typeof dialog.close === 'function') {
          if (dialog.open) dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      }

      dialog.querySelectorAll('[data-uk-redirect-close]').forEach((el) => {
        el.addEventListener('click', dismiss);
      });

      const go = dialog.querySelector('[data-uk-redirect-go]');
      if (go) {
        go.addEventListener('click', writeDismissed);
        go.setAttribute('href', url);
      }

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        dismiss();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dismiss();
      });

      const preview = new URLSearchParams(window.location.search).get('uk_popup') === '1';

      if (designMode || preview) {
        show();
        return;
      }

      if (readDismissed()) return;

      function isUkVisitor(code) {
        if (countries.indexOf(code) !== -1) return true;
        try {
          if (Intl.DateTimeFormat().resolvedOptions().timeZone === 'Europe/London') return true;
        } catch (e) {}
        return String(navigator.language || '').toUpperCase() === 'EN-GB';
      }

      detectCountry(dialog.getAttribute('data-country')).then((code) => {
        if (isUkVisitor(code)) show();
      });
    }

    roots.forEach(bind);
  })();

  } catch(e) { console.error(e); }
})();
})();
